const state = {
  currentRole:{
    id: null,
    name: ''
  },
  rolesEdit: null,
  rolesDelete: null
}

export default state